import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[dateInput]',
  standalone: false
})
export class DateInputDirective {
  // Regex to allow only digits (0-9) and the slash (/)
  private regex: RegExp = new RegExp(/^[0-9/]*$/);

  // Keys that should always be allowed (Backspace, Tab, etc.)
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];

  @HostListener('paste', ['$event'])
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special navigation keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    // Check if the pressed key matches the regex
    const current: string = event.key;
    if (!String(current).match(this.regex)) {
      event.preventDefault(); // Block the input
    }
  }
}